const defaultCompare = <T>(left: T, right: T): number => {
  const leftValue = String(left);
  const rightValue = String(right);
  if (leftValue < rightValue) {
    return -1;
  }
  if (leftValue > rightValue) {
    return 1;
  }
  return 0;
};

declare global {
  interface ReadonlyArray<T> {
    toSorted(compareFn?: (a: T, b: T) => number): T[];
  }
}

export const toSortedCompat = <T>(values: readonly T[], compareFn?: (a: T, b: T) => number): T[] =>
  values.toSorted(compareFn ?? defaultCompare);
